<script lang="ts" setup>

//vue
import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/vouchersService";
import { fdata, fdataHora, fdataUS } from "@/utils/funcoes";

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";

interface IProps {
  ClienteId?: number
}

var props = defineProps<IProps>();

var controle = reactive({
  clienteId: props.ClienteId as number | null | undefined,
  indicados: [] as service.Voucher[],
  clienteIndicou: {} as service.Voucher,

  model: {
    indicadorId: props.ClienteId
  } as service.Voucher,
  janela: false,
  janPergunta: false,
  erro: "",
  status: ""
})

onMounted(() => {

  buscarIndicador();
  buscarIndicados();

});

watch(() => props.ClienteId, (newValue) => {
  controle.clienteId = newValue;
  controle.model.indicadorId = newValue ?? 0;
  buscarIndicados();
  buscarIndicador();
});


async function buscarIndicador() {

  if (!props.ClienteId) {
    controle.clienteIndicou = {} as service.Voucher;
    return;
  }

  console.log("buscar indicador", props.ClienteId);

  controle.status = "Buscando items...";
  controle.erro = "";
  service.obter({ indicadoId: props.ClienteId } as service.Filtros)
    .then((r) => {
      controle.clienteIndicou = r[0] || {} as service.Voucher;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function buscarIndicados() {

  if (!props.ClienteId) {
    controle.indicados = [];
    return;
  }

  console.log("buscar indicados", props.ClienteId);
  controle.status = "Buscando items...";
  controle.erro = "";
  service.obter({ indicadorId: props.ClienteId } as service.Filtros)
    .then((r) => {
      controle.indicados = r;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function salvar() {

  controle.status = "Salvando item...";
  controle.erro = "";

  if (controle.model.dataPagamento != null) {
    controle.model.dataPagamento = fdataUS(controle.model.dataPagamento);
  }

  controle.model.indicadorId = controle.clienteId ?? 0;

  service.salvar(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = {
        indicadorId: props.ClienteId ?? 0,
      } as service.Voucher;
      buscarIndicados();
      controle.janela = false;
    })
    .catch((error) => {
      controle.erro = `Erro ao salvar item: ${error}`;
      controle.status = "";
    });
}

function excluir(item: service.Voucher) {
  controle.model = item;
  controle.janPergunta = true;
}

function excluirConfirma() {
  controle.janPergunta = false;
  controle.status = "Excluindo item...";
  controle.erro = "";

  service.excluir(controle.model.voucherId)
    .then(() => {
      controle.status = "";
      controle.model = {
        indicadorId: controle.model.indicadorId
      } as service.Voucher;
      buscarIndicados();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
}

function statusTexto(status: number) {
  switch (status) {
    case 0:
      return "Aguardando Pagamento";
    case 1:
      return "Pago";
    case 2:
      return "Cancelado";
    default:
      return status;
  }
}

function statusBadge(status: number) {
  switch (status) {
    case 0:
      return "badge bg-warning";
    case 1:
      return "badge bg-success";
    case 2:
      return "badge bg-danger";
    default:
      return "badge bg-secondary";
  }
}

</script>

<template>
  <TrataTecla>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
      <div class="card-header">
        <h5 class="card-title">Vouchers</h5>
      </div>
      <div class="card-body p-3" v-if="!props.ClienteId">
        <div class="row mb-2">
          <div class="col-md-12">
            <p class="">Necessário cadastro do cliente</p>
          </div>
        </div>
      </div>
      
      <div class="card-body p-3" v-else>
        <!-- <div class="row mb-2">
          <div class="col-md-6">
            <a class="btn btn-sm btn-primary " @click="controle.janela = true">Adicionar</a>
          </div>
        </div> -->

        <div class="row mb-3" v-if="controle.clienteIndicou.indicadorId != null">
          <div class="col-md-12">
            Indicado por
          </div>

          <div class="col-md-1">
            <label>Código</label>
            <input type="text" class="form-control form-control-sm" v-model="controle.clienteIndicou.indicadorId"
              disabled readonly />
          </div>

          <div class="col-md-4">
            <label>Indicado por</label>
            <input type="text" class="form-control form-control-sm" :value="controle.clienteIndicou?.indicador?.nome"
              disabled readonly />
          </div>

          <div class="col-md-2">
            <label>Data Cadastro</label>
            <input type="text" class="form-control form-control-sm"
              :value="fdataHora(controle.clienteIndicou?.dataCadastro)" disabled readonly />
          </div>

          <div class="col-md-2">
            <label>Status</label>
            <div class="d-block badge" :class="statusBadge(controle.clienteIndicou?.status)">{{
              statusTexto(controle.clienteIndicou?.status) }}</div>
          </div>
        </div>



        <div class="row mb-2 mt-2">
          <div class="col-md-12">
            Clientes Indicados (Indicações)
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-12 table-responsive">
            <table class="table table-sm table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-end">Cliente</th>
                  <th>Nome</th>
                  <th>Dt Pagamento</th>
                  <th>CPF</th>
                  <th>Celular</th>
                  <th class="text-end">Nro Voucher</th>
                  <th>Status</th>
                  <!-- <th>Ações</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in controle.indicados" :key="index">
                  <td class="text-end">{{ item.indicadoId }}</td>
                  <td>{{ item.indicado?.nome }}</td>
                  <td>{{ fdataHora(item.dataCadastro) }}</td>
                  <td>{{ fdata(item.dataPagamento) }}</td>
                  <td>{{ item.status }}</td>
                  <td class="text-end">{{ item.voucherId }}</td>
                  <td>
                    <div class="badge" :class="statusBadge(item.status)">{{ statusTexto(item.status) }}</div>
                  </td>
                  <!-- <td>
                    <button class="btn btn-sm btn-primary me-1" title="Alterar registro"
                      @click="controle.model = item; controle.janela = true">
                      <i class="flaticon-edit"></i>
                    </button>

                    <button class="btn btn-sm btn-danger" title="Excluir registro" @click="excluir(item)">
                      <i class="flaticon-delete"></i>
                    </button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <p class="">Registros: {{ controle.indicados.length }}</p>
          </div>
        </div>
        <div class="text-center">
          <span class="">{{ controle.status }}</span>
          <span class="text-danger fw-bold">{{ controle.erro }}</span>
        </div>
      </div>
    </div>
  </TrataTecla>

  <!-- <TrataTecla>
    <MsgBox :id="'janAddDep'" class="modal-md" data-bs-backdrop="static" :exibir="controle.janela"
      :titulo="'Cadastro de Dependente'" @on-fechou="controle.janela = false" :botao-gravar="true" :botao-fechar="true"
      @on-gravar="salvar()">
      <div class="row mb-2">
        <div class="col-md-3">
          Parentesco
        </div>
        <div class="col-md-9">
          <select v-model="controle.model.parentesco" class="form-select form-select-sm">
            <option :value="null">- Selecione - </option>
            <option value="Filho">Filho</option>
            <option value="Filha">Filha</option>
            <option value="Pai">Pai</option>
            <option value="Mae">Mãe</option>
            <option value="Neto">Neto</option>
            <option value="Neta">Neta</option>
            <option value="Conjuge">Cônjuge</option>
          </select>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          Nome
        </div>
        <div class="col-md-9">
          <TextBox v-model="controle.model.nome" :formato="'Texto'" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          Dt Nascimento
        </div>
        <div class="col-md-9">
          <TextBox v-model="controle.model.dataNascimento" :formato="'Data'" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          CPF
        </div>
        <div class="col-md-9">
          <TextBox v-model="controle.model.cpf" :formato="'CpfCnpj'" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          Celular
        </div>
        <div class="col-md-9">
          <TextBox v-model="controle.model.celular" :formato="'Telefone'" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <span class="">{{ controle.status }}</span>
          <span class="text-danger fw-bold">{{ controle.erro }}</span>
        </div>
      </div>

    </MsgBox>
  </TrataTecla> -->

  <MsgBox :id="'janPerguntaVoucher'" class="modal-md" data-bs-backdrop="static" :exibir="controle.janPergunta"
    :titulo="'Atenção'" @on-fechou="controle.janPergunta = false" :botao-sim="true" :botao-nao="true"
    @on-sim="excluirConfirma()">
    <div class="row mb-2">
      <div class="col-md-12 fs-5 fw-bold text-center ">
        Deseja excluir este registro ?
      </div>
    </div>
  </MsgBox>

</template>